import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=f06bd2f4&scoped=true&"
import script from "./Assets.vue?vue&type=script&lang=js&"
export * from "./Assets.vue?vue&type=script&lang=js&"
import style0 from "./Assets.vue?vue&type=style&index=0&id=f06bd2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06bd2f4",
  null
  
)

export default component.exports